var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"um-menu-item-group"},[_c('div',{class:['uw-menu-item-group-title', _vm.isActive ? 'is-active' : '' ]},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('div',{staticClass:"uw-menu-item-group-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }